import React from"react";import{TextInput}from"../../../../fields/TextInput/TextInput";export const TextFilter=props=>React.createElement(TextInput,props);